import React from 'react';
import { RiAddCircleLine } from '@remixicon/react';
import {
  type IconComponent,
  createFrontendModule,
  PageBlueprint,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';

export const createPagesModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/create',
        routeRef: scaffolderPlugin.routes.root,
        noHeader: true,
        loader: () =>
          import('./create.page').then(m => React.createElement(m.CreatePage)),
      },
    }),
    NavItemBlueprint.make({
      params: {
        title: 'Create',
        icon: RiAddCircleLine as IconComponent,
        routeRef: scaffolderPlugin.routes.root,
      },
    }),
  ],
});
